module.exports = __webpack_public_path__ + "static/media/nav-arrow.45eb65ae.svg";